import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

let baseStyles = {
    container: {
        marginHorizontal: Theme.primaryMargin,
        paddingVertical: Theme.primaryMargin,
        marginTop: Device.isTabletOrWeb ? -25 : 0,
        justifyContent: Device.isTabletOrWeb ? null : 'center',
        alignItems: 'center'
    },
    innerConteiner: {
        justifyContent: Device.isTabletOrWeb ? 'center' : null,
        alignItems: Device.isTabletOrWeb ? 'center' : null,
        width: Device.isTabletOrWeb ? 'auto' : Device.width
    },
    inputAndButtonConteiner: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Theme.fontSizes.title,
        marginBottom: 16,
        paddingTop: 10,
        textAlign: 'center'
    },
    description: {
        fontFamily: Theme.regularFont,
        marginVertical: 25,
        color: Theme.primaryTextColor,
        fontSize: Theme.primaryFontSize,
        textAlign: 'center',
        paddingHorizontal: 10,
        width: Device.isTabletOrWeb ? 500 : 300
    },
    grayText: {
        color: Theme.secondaryTextColor,
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        marginBottom: 35,
        textAlign: 'left',
        maxWidth: Device.isTabletOrWeb ? 500 : 300
    },
    infoBox: {
        marginTop: 25,
        paddingVertical: 2
    },
    input: {
        fontFamily: Theme.regularFont,
        alignSelf: 'stretch',
        backgroundColor: '#FFFFFF',
        fontSize: 21,
        color: '#333333',
        height: 55,
        borderRadius: 3,
        paddingHorizontal: 20,
        marginBottom: 0,
        minWidth: '100%'
    },
    button: {
        width: '100%',
        maxWidth: 300
    },
    link: {
        marginTop: 16,
        fontSize: 18
    },
    successIcon: {
        height: 100,
        width: 100,
        marginBottom: 16
    },
    buttonsContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        flexDirection: 'column'
    },
    textinputConteiner: {
        width: Device.isTabletOrWeb ? 500 : 300,
        minWidth: Device.isTabletOrWeb ? 500 : 300,
        justifyContent: 'center',
        alignItems: 'center'
    },
    checkBoxContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'stretch',
        marginBottom: 36,
        marginTop: 20
    },
    checkBoxText: {
        color: '#ffffff',
        marginLeft: 12,
        fontFamily: Theme.regularFont,
        fontSize: 18
    },
    checkbox: {
        zIndex: 1
    },
    buttonWidth: {
        minWidth: 300
    },
    firstButtonMargin: {
        marginBottom: 20,
        marginTop: 20,
        minWidth: 300
    },
    keyboardAvoidingStyle: {
        flex: 1,
        alignItems: 'center'
    },
    buttonSingleContainer: {
        alignSelf: 'center',
        flex: 1,
        minWidth: 300
    },
    buttonSpacing: { marginTop: 10, width: '100%' }
};

export const buttonStyle = StyleSheet.create({
    button: {
        marginBottom: 15,
        maxWidth: 300
    }
});

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            ...baseStyles.container,
            marginHorizontal: '20%'
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse',
            justifyContent: 'space-around'
        }
    };
}

export default StyleSheet.create(baseStyles);
